import { ReactNode } from 'react';

type TableFooterProps = {
  children?: ReactNode;
};

export const TableFooter = ({ children }: TableFooterProps): JSX.Element => (
  <div
    style={{
      position: 'sticky',
      bottom: 0,
      left: 0,
      background: '#fff',
      paddingBlock: 1,
      paddingInline: 12,
    }}
  >
    {children}
  </div>
);
